import React from "react";

export default ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
    <path fill={color} d="M16 7H3.83l5.59-5.59L7.999 0 0 8l7.999 8 1.41-1.41L3.83 9H16V7z" />
  </svg>
);
